<template>
	<div class="card card-body border-0 wrapper-box p-0 text-center mb-4 product-container position-relative">
		<router-link
			class="plain-link"
			:to="detailLink(product)">
			<div class="product-img" :class="{ 'blur' : isProductPrivate }">
				<!-- <img
					:src="product.picture"
					:alt="'Product'"
					v-if="!isLoading"
					:style="getStyleImg"
					class="cursor-pointer"
					@click="showDetail"
				/> -->
				<img
					:src="productImage"
					:alt="'Product'"
					class="cursor-pointer"
					@click="showDetail"
					v-if="!isLoading"
				/>
				<shimmer
					v-else
					width="250px"
					height="180px"
				/>
				<div :class="{'gradient-background' : isGradientEnabled}"></div>
			</div>
		</router-link>

		<!-- Percent Off Ribbon -->
		<div class="ribbon-container" v-if="getPercentOff(product) !== '-' && getPercentOff(product) !== '0%'">
			<span class="ribbon-text">{{ getPercentOff(product) }}</span>
			<span class="ribbon-tail"></span>
		</div>

		<div class="product-detail-container" :class="{ 'blur' : isProductPrivate }">
			<router-link class="plain-link" :to="detailLink(product)">
				<div class="product-name cursor-pointer" @click="showDetail">
					<span v-if="!isLoading">{{ truncateText(product.name, 61) }}</span>
					<shimmer
						v-else
						height="30px"
					/>
				</div>
			</router-link>
			<badges :is-cod-enabled="isCODEnabled" :is-lp-enabled="isLpEnabled" :is-marketing-kit-enabled="isMarketingKitEnabled" v-if="!isLoading"></badges>
			<div v-else class="text-left">
				<shimmer
					width="25px"
					height="17px"
				/>
			</div>
			<div class="product-detail text-left mt-2">
				<div class="product-price-detail">
					<!-- Buy Price without sale price -->
					<!-- <div v-if="!isLoading" class="capital">
						<span class="label-700" v-if="!isLoading">Harga Modal : </span> <br>
						<span class="label-price color-price" v-if="!isLoading">{{ product.type == 'variable' ? basePriceRange(product) : getBasePrice(product) }}</span>
					</div> -->
					<!-- Buy Price with sale price -->
					<div v-if="!isLoading" class="capital">
						<span class="label-700" v-if="!isLoading">Harga Modal : </span> <br>
						<span class="label-price color-price" v-if="!isLoading">{{ product.type == 'variable' ? getOriginalPriceRange(product) : getOriginalPrice(product) }}</span> <br>
						<span
							class="label-price color-price sale-price"
							:class="{ 'invisible': !checkHasSalePrice(product) }"
							v-if="!isLoading"
						>
							{{ product.type == 'variable' ? basePriceRange(product) : getBasePrice(product) }}
						</span>
					</div>
					<shimmer
						v-else
						height="10px"
					/>
					<div v-if="!isLoading" class="selling">
						<span class="label-700" v-if="!isLoading">Rekomendasi Harga Jual : </span><br>
						<span class="label-price color-selling-price" v-if="!isLoading">{{ product.type == 'variable' ? getFinalPriceRange(product) : getFinalPrice(product) }}</span>
					</div>
					<shimmer
						v-else
						width="100px"
						height="10px"
					/>
				</div>
				<div class="location-stock row m-0 mt-2">
					<div class="location col-6 p-0">
						<div class="d-flex" v-if="!isLoading">
							<span class="map-icon pr-1"><i class="bi bi-geo-alt-fill"></i></span>
							<div v-if="product.shipping.origin.warehouse_id">
								<span class="label warehouse-label text-primary" v-if="!isLoading">WH Ostock</span>
								<span class="label origin" v-if="!isLoading">{{ getShippingOrigin(product) }}</span>
							</div>
							<div v-else>
								<span class="label" v-if="!isLoading">{{ getShippingOrigin(product) }}</span>
							</div>
						</div>
						<shimmer
							v-else
							width="50px"
							height="10px"
						/>
					</div>
					<div class="stock col-6 text-right p-0">
						<div v-if="!isLoading">
							<span class="label pr-1">Stok :</span>
							<span class="total" v-if="!isLoading">{{ getStockQuantity(product) }}</span>
						</div>
						<shimmer
							v-else
							width="50px"
							height="10px"
						/>
					</div>
				</div>
			</div>
			<div class="product-detail-button" v-if="!isEditMode">
				<template v-if="!isLoading">
					<!-- <div class="dropdown" v-if="user">
						<button
							class="btn-outline o-sm outline-primary btn-block"
							:class="{ 'is-loading': isAddingProduct || isGenerating }"
							type="button"
							data-toggle="dropdown"
							aria-expanded="false"
						>
							Jual Sekarang
						</button>
						<div class="dropdown-menu w-100">
							<button type="button" class="dropdown-item" @click="onClickAddProduct()" :disabled="isProductAdded">{{ isProductAdded ? '✓' : '+' }} Jual di Orderonline</button>
							<button type="button" class="dropdown-item" @click="onClickDirectOrder()">+ Direct Order</button>
						</div>
					</div> -->
					<div class="d-flex">
						<button
							class="btn-outline o-sm outline-primary w-100 btn-sell-now"
							:class="{ 'is-loading': isAddingProduct }"
							@click="onClickAddProduct()"
							:disabled="isDisabled"
						>
							<span v-if="isProductAdded">
								✓ Ditambahkan
							</span>
							<span v-else>
								<span v-if="isProductPrivate">
									Private
								</span>
								<span v-else>
									Jual Sekarang
								</span>
							</span>
						</button>
						<button
							class="btn-outline o-sm outline-primary ml-2" @click="addToWishlist" v-if="user">
							<span :class="{ 'is-loading': isAddingWishlist }">
								<i class="bi bi-heart-fill text-danger" v-if="isProductWishlisted" :style="favoriteIconStyle"></i>
								<i class="bi bi-heart" v-else :style="favoriteIconStyle"></i>
							</span>
						</button>
					</div>
				</template>
				<shimmer
					v-else
					:maxWidth="100"
					:height="'40px'"
				/>
			</div>
		</div>
		<div class="cursor-pointer checkbox-container" v-if="isEditMode" @click="showDetail">
			<i class="material-icons text-white bg-primary rounded" v-if="isChecked">check</i>
			<div class="checkbox-blank rounded" v-else></div>
		</div>
		<overlay v-if="isProductPrivate">
			Private
		</overlay>
		<!-- Notifications -->
		<notifications group="dropship" position="bottom right"></notifications>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
	getAxiosErrorMessage,
	formatNumberPlain,
	truncateText,
	getDropshipFinalPrice,
	getDropshipVariationFinalPrice,
	getProductPricePlusCommission,
	getSimpleProductOriginalPrice,
	calculateDiscount,
	isHasFeature,
	formatMoney,
	getShippingOrigin,
	isPrivate,
	duplicateVar,
} from '@/lib/helper';
import Shimmer from '@/components/Shimmer.vue';
import Overlay from '@/components/homepages/sections/partials/Overlay.vue';
import Badges from '@/components/products/Badges.vue';
import dropshipApi from '@/api/dropship';
import productApi from '@/api/products';
import orderonlineApi from '@/api/orderonline';
import wishlistApi from '@/api/wishlist';

export default {
	name: 'ProductItem',
	components: {
		Shimmer,
		Overlay,
		Badges,
	},
	props: {
		product: {
			type: Object,
			default: null,
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
		isEditMode: {
			type: Boolean,
			default: false,
		},
		isGradientEnabled: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isAddingProduct: false,
			isGenerating: false,
			ooProduct: null,
			defaultImage: 'https://cdn.ostock.id/img/default-product.png',
			isAddingWishlist: false,
			isChecked: false,
		};
	},
	methods: {
		...mapActions({
			getDropshipProductAdded: 'homepage/getDropshipProductAdded',
			appendProductAdded: 'homepage/appendProductAdded',
			funnelDuplicate: 'homepage/funnelDuplicate',
			getProductWishlistAdded: 'wishlist/getProductWishlistAdded',
			appendWishlistAdded: 'wishlist/appendWishlistAdded',
			removeWishlistAdded: 'wishlist/removeWishlistAdded',
		}),
		detailLink(product) {
			const encodedUserId = btoa(product?.user?._id?.$oid);
			const url = `/product/${product?.slug}-${encodedUserId}`;
			return url;
		},
		getStockQuantity(product) {
			const isEnabledStock = product.stock.enabled;
			let quantity = '-';
			if (isEnabledStock) {
				const isSimple = product.type === 'simple';
				const variationPrice = product.variations.prices.reduce(
					(prevQty, variation) => {
						const variationQuantity = variation.stock
							? variation.stock.quantity
							: 0;
						const totalQuantity = prevQty + variationQuantity;
						return totalQuantity;
					},
					0,
				);
				quantity = `${isSimple ? product.stock.quantity : variationPrice}`;
			}
			return quantity;
		},
		getShippingOrigin,
		truncateText,
		toggleCheck() {
			this.isChecked = !this.isChecked;
			if (this.isChecked) {
				this.$emit('append-product-id', this.productId);
			} else {
				this.$emit('remove-product-id', this.productId);
			}
		},
		showDetail() {
			if (this.isEditMode) {
				this.toggleCheck();
			} else {
				this.$emit('showDetail', this.product);
			}
		},
		getFinalPrice(product, format = true) {
			const price = getDropshipFinalPrice(product, [], 1, true, false);
			return format ? this.formatMoney(price) : price;
		},
		getBasePrice(product) {
			const pricePlusCommission = getProductPricePlusCommission(product);
			const price = formatNumberPlain(pricePlusCommission);
			const splittedPrice = price.split('.');
			let censoredPrice = '';
			splittedPrice.forEach((val, index) => {
				if (index === 0) {
					censoredPrice += 'X'.repeat(val.length);
				} else {
					censoredPrice += `.${val}`;
				}
			});
			return `Rp${(this.user ? price : censoredPrice)}`;
		},
		onClickAddProduct() {
			if (!this.user) {
				this.$router.push({ path: '/login' });
			} else if (!this.isOoLoggedIn) {
				this.$router.push({ path: '/settings/connections', query: { msg: 'oo_account' } });
			} else {
				this.sellProduct(this.product);
			}
		},
		sellProduct(product) {
			// sell product oo - DEPCRECATED METHOD
			// this.sellProductOO(product, bulk);
			// duplicate LP - DEPCRECATED METHOD
			// this.duplicateFunnel(product);

			this.addProductToOO(product);
		},
		addProductToOO(product) {
			this.isAddingProduct = true;

			let productId = product._id;
			if (typeof product._id === 'object') {
				productId = product._id.$oid;
			}

			const params = {
				product_id: productId,
				duplicate_funnel: false,
			};

			const callback = (response) => {
				const addedProduct = response.data.added;
				this.appendProductAdded(addedProduct);
				this.funnelDuplicate(addedProduct);

				this.$notify({
					group: 'app',
					title: 'Success add product',
					text: `Berhasil menambah produk ${product.name}`,
					type: 'success',
				});

				this.isAddingProduct = false;
			};

			const errorCallback = (e) => {
				let message = getAxiosErrorMessage(e);
				message = e.response.status === 400 && message === 'invalid_connection' ? '<span>Account connection is not valid. <a class="disabled-style-link text-white" href="/settings/connections">Click here to reconnect account.</a></span>' : message;
				this.$notify({
					group: 'app',
					title: 'Failed add product',
					text: message,
					type: 'error',
				});
				this.isAddingProduct = false;
			};

			orderonlineApi.addDropshipProduct(params, callback, errorCallback);
		},
		sellProductOO(product, bulk = false) {
			this.isAddingProduct = true;
			product.dropship.original_price = product.price;
			const params = {
				name: product.name,
				autoresponders: JSON.stringify(product.autoresponders),
				bump: JSON.stringify(product.bump),
				category: JSON.stringify(product.category),
				code: product.code,
				collections: JSON.stringify(product.collections),
				description: product.description,
				form: JSON.stringify(product.form),
				pictures: JSON.stringify(product.pictures),
				slug: product.slug,
				type: product.type,
				price: getDropshipFinalPrice(product, [], 1, !this.isOfficialSeller), // normal seller(hpp + komisi + margin) x official seller(hpp + komisi)
				sale_price: JSON.stringify(product.sale_price),
				weight: product.weight,
				shipping: JSON.stringify(product.shipping),
				dropship: JSON.stringify(product.dropship),
				variations: JSON.stringify(getDropshipVariationFinalPrice(product, this.isOfficialSeller, !this.isOfficialSeller)), // normal seller(hpp + komisi + margin) x official seller(hpp + komisi)
				is_deleted: product.is_deleted,
				is_public: this.isOfficialSeller,
				max_quantity: JSON.stringify(product.max_quantity),
				// notifications: JSON.stringify(product.notifications),
				notifications: JSON.stringify([]),
				order_distribution: JSON.stringify(product.order_distribution),
				payment_channels: JSON.stringify(product.payment_channels),
				payment_channels_descriptions: JSON.stringify(
					product.payment_channels_descriptions,
				),
				payment_methods_descriptions: JSON.stringify(
					product.payment_methods_descriptions,
				),
				payments: JSON.stringify(product.payments),
				status: product.status,
				stock: JSON.stringify(product.stock),
				unique_code_price: JSON.stringify(product.unique_code_price),
				wholesale: JSON.stringify(this.getWholesalePrice(product)),
				facebook_custom_audiences: JSON.stringify(
					product.facebook_custom_audiences,
				),
				source_id: product._id.$oid,
				source_type: 'ostock',
				source_user_id: product.user._id.$oid,
				pages: JSON.stringify(product.pages),
				videos: JSON.stringify(product.videos),
				commission_percentage: product.commission_percentage,
			};
			if (product.outsource_commission) {
				params.outsource_commission = JSON.stringify(product.outsource_commission);
			}
			const callback = (res) => {
				const OoProduct = res.data;
				this.ooProduct = OoProduct;
				// this.addedDropship.push({ source_id: product._id.$oid });
				// re-fetch added dropship
				this.getDropshipProductAdded();

				// const index = this.selectedProducts.findIndex(
				// 	el => el.product._id.$oid === product._id.$oid,
				// );
				// if (index !== -1) {
				// 	this.selectedProducts.splice(index, 1);
				// }

				this.isAddingProduct = false;
				this.isShowAddProduct = false;
				this.addProduct(product._id.$oid, {
					price: getDropshipFinalPrice(product, [], 1, !this.isOfficialSeller),
					source_type: 'orderonline',
					reference_id: OoProduct._id,
				});
				if (!bulk) {
					this.$notify({
						group: 'dropship',
						title: 'Dropship',
						text: `Berhasil menambah produk ${product.name}`,
						type: 'success',
					});
				}
			};
			const errorCallback = (e) => {
				this.isAddingProduct = false;
				const message = getAxiosErrorMessage(e);
				if (message || message !== '') {
					this.$notify({
						group: 'dropship',
						title: 'Dropship',
						text: message,
						type: 'error',
					});
				}
				console.log('message: ', e);
			};
			console.log(params);
			dropshipApi.addDropshipProduct(
				product._id.$oid,
				params,
				callback,
				errorCallback,
			);
		},
		duplicateFunnel(product) {
			const pages = product.pages ? product.pages : [];
			if (pages.length > 0) {
				const pageIds = pages.map(page => page.url.replace('https://app.orderonline.id/funnels/sharer/', ''));

				const params = {
					ids: JSON.stringify(pageIds),
					all_pages: true,
				};
				// console.log('funnels', params);
				const callback = (res) => {
					const responseData = res.data;
					if (responseData.new_objects && responseData.new_objects.length > 0) {
						const newFunnelId = responseData?.new_objects[0]?._id ?? null;
						this.updateFunnelProduct(newFunnelId);
					}

					this.isAddingProduct = false;
					this.isShowAddProduct = false;

					// console.log('duplicate success');
				};
				const errorCallback = (e) => {
					this.isAddingProduct = false;
					const message = getAxiosErrorMessage(e);
					if (message || message !== '') {
						this.$notify({
							group: 'dropship',
							title:
								'Error duplicate funnel page into your orderonline account',
							text: message,
							type: 'error',
						});
					}
					console.log('message: ', e);
				};
				dropshipApi.duplicateFunnel(params, callback, errorCallback);
			}
		},
		updateFunnelProduct(funnelId) {
			if (funnelId !== null) {
				const productId = this.ooProduct?._id ?? '';
				const params = {
					funnel_id: funnelId,
					product_id: productId,
				};

				const callback = (res) => {
					const responseData = res.data;
					if (responseData.new_objects && responseData.new_objects.length > 0) {
						const newFunnelId = responseData?.new_objects[0]?._id ?? null;
						this.updateFunnelProduct(newFunnelId);
					}
					this.isAddingProduct = false;
					this.isShowAddProduct = false;

					// console.log('update funnel success', res);
				};
				const errorCallback = (e) => {
					this.isAddingProduct = false;
					const message = getAxiosErrorMessage(e);
					console.log('message: ', message);
				};
				dropshipApi.updateProductFunnel(params, callback, errorCallback);
			}
		},
		async addProduct(id, params) {
			await productApi.addDropshipProduct(id, params);
		},
		onClickDirectOrder() {
			const link = `${this.getStorefrontOstock}/product-link`;
			const productId = this.product._id.$oid;

			this.isGenerating = true;
			const params = {
				product_id: productId,
			};
			const callback = (response) => {
				const token = response.data;

				window.open(`${link}/${productId}/?token=${token}`, '_blank');
				this.isGenerating = false;
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'dropship',
					title: 'Private Order',
					text: message,
					type: 'error',
				});
				this.isGenerating = false;
			};

			orderonlineApi.createCustomer(params, callback, errorCallback);
		},
		getWholesalePrice(product) {
			return this.isOfficialSeller ? product.wholesale : [];
		},
		getFinalPriceRange(product) {
			const variations = getDropshipVariationFinalPrice(product, this.isOfficialSeller, !this.isOfficialSeller, false);
			let firstPrice = null;
			let secondPrice = null;
			(variations.prices).forEach((element) => {
				if (firstPrice == null) {
					firstPrice = element.price;
				} else if (firstPrice > element.price) {
					firstPrice = element.price;
				}
				if (secondPrice == null) {
					secondPrice = element.price;
				} else if (secondPrice < element.price) {
					secondPrice = element.price;
				}
			});

			firstPrice = formatMoney(firstPrice);
			secondPrice = formatMoney(secondPrice);

			const price = firstPrice !== secondPrice ? `${firstPrice} - ${secondPrice}` : firstPrice;

			return price;
		},
		basePriceRange(product) {
			const variations = getDropshipVariationFinalPrice(product, this.isOfficialSeller, false);
			let firstPrice = null;
			let secondPrice = null;
			(variations.prices).forEach((element) => {
				if (firstPrice == null) {
					firstPrice = element.price;
				} else if (firstPrice > element.price) {
					firstPrice = element.price;
				}
				if (secondPrice == null) {
					secondPrice = element.price;
				} else if (secondPrice < element.price) {
					secondPrice = element.price;
				}
			});

			const formattedFirstPrice = !this.user ? this.elipsisPrice(firstPrice) : formatMoney(firstPrice);
			const formattedSecondPrice = !this.user ? this.elipsisPrice(secondPrice) : formatMoney(secondPrice);

			const price = firstPrice !== secondPrice ? `${formattedFirstPrice} - ${formattedSecondPrice}` : formattedFirstPrice;

			return price;
		},
		getOriginalPrice(product) {
			const originalPrice = getSimpleProductOriginalPrice(product);
			const formattedPrice = formatNumberPlain(originalPrice);
			const [integerPart, decimalPart] = formattedPrice.split('.');

			const censoredPrice = 'X'.repeat(integerPart.length) + (decimalPart ? `.${decimalPart}` : '');

			return `Rp${this.user ? formattedPrice : censoredPrice}`;
		},
		getOriginalPriceRange(product) {
			const variations = getDropshipVariationFinalPrice(product, this.isOfficialSeller, false, false);
			let minPrice = null;
			let maxPrice = null;
			const variationPrices = variations?.prices ?? [];

			variationPrices.forEach((variation) => {
				const price = variation?.price ?? 0;

				if (minPrice === null || price < minPrice) {
					minPrice = price;
				}
				if (maxPrice === null || price > maxPrice) {
					maxPrice = price;
				}
			});

			const formattedMinPrice = !this.user ? this.elipsisPrice(minPrice) : formatMoney(minPrice);
			const formattedMaxPrice = !this.user ? this.elipsisPrice(maxPrice) : formatMoney(maxPrice);

			return minPrice !== maxPrice ? `${formattedMinPrice} - ${formattedMaxPrice}` : formattedMinPrice;
		},
		checkHasSalePrice(product) {
			const originalPrice = product?.type === 'variable' ? this.getOriginalPriceRange(product) : this.getOriginalPrice(product);
			const salePrice = product?.type === 'variable' ? this.basePriceRange(product) : this.getBasePrice(product);

			const isDifferent = originalPrice !== salePrice;

			if (!this.user) {
				return true;
			}

			return isDifferent;
		},
		getSimplePercentOff(product) {
			const pricePlusCommission = getProductPricePlusCommission(product);
			const originalPrice = getSimpleProductOriginalPrice(product);
			return this.user ? calculateDiscount(pricePlusCommission, originalPrice) : 'XX%';
		},
		getVariablePercentOff(product) {
			const variationsSalePrices = getDropshipVariationFinalPrice(product, this.isOfficialSeller, false);
			const variationsOriginalPrices = getDropshipVariationFinalPrice(product, this.isOfficialSeller, false, false);

			let highestPercentOff = 0;

			const salePrices = variationsSalePrices?.prices ?? [];
			const originalPrices = variationsOriginalPrices?.prices ?? [];

			salePrices.forEach((variant, idx) => {
				const isVariantEnabled = variant?.enabled ?? true;
				if (!isVariantEnabled) return;

				const salePrice = variant?.price ?? 0;
				const originalPrice = originalPrices[idx]?.price ?? 0;

				const percentOff = calculateDiscount(salePrice, originalPrice, false);

				if (percentOff > highestPercentOff) {
					highestPercentOff = percentOff;
				}
			});

			return this.user ? `${highestPercentOff}%` : 'XX%';
		},
		getPercentOff(product) {
			return product?.type === 'variable' ? this.getVariablePercentOff(product) : this.getSimplePercentOff(product);
		},
		elipsisPrice(value) {
			const price = formatNumberPlain(value);
			const splittedPrice = price.split('.');
			let censoredPrice = '';
			splittedPrice.forEach((val, index) => {
				if (index === 0) {
					censoredPrice += 'X'.repeat(val.length);
				} else {
					censoredPrice += `.${val}`;
				}
			});
			return `Rp${this.user ? price : censoredPrice}`;
		},
		addToWishlist() {
			this.isAddingWishlist = true;

			const type = this.isProductWishlisted ? 'remove' : 'add';

			const productId = this.productId;

			const params = {
				product_id: productId,
			};

			const callback = (response) => {
				this.isAddingWishlist = false;
				const message = response.message || 'Success';
				this.$notify({
					group: 'app',
					title: 'Wishlist',
					text: message,
					type: 'success',
				});

				const product = {
					_id: productId,
				};

				if (type === 'add') {
					this.appendWishlistAdded(product);
				} else {
					this.removeWishlistAdded(product);
					this.$emit('remove-wishlist', productId);
				}
			};

			const errorCallback = (e) => {
				this.isAddingWishlist = false;
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					title: 'Wishlist',
					text: message,
					type: 'error',
				});
			};

			if (type === 'add') {
				wishlistApi.addWishlist(params, callback, errorCallback);
			} else {
				wishlistApi.removeWishlist(productId, callback, errorCallback);
			}
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isOoLoggedIn: 'isOoLoggedIn',
			isUserCan: 'isUserCan',
			productAdded: 'homepage/productAdded',
			wishlistAdded: 'wishlist/wishlistAdded',
			ooWeb: 'ooWeb',
		}),
		getStyleImg() {
			const character = this.product.name.length || 0;
			let style = 'height: 241px;';
			if (character <= 37) {
				style = 'height: 265px;';
			}
			return style;
		},
		isProductAdded() {
			return this.productAdded.findIndex(myid => myid.source_id === this.product._id.$oid) !== -1;
		},
		isProductWishlisted() {
			return this.wishlistAdded.findIndex(wishlistedProduct => wishlistedProduct._id === this.product._id.$oid) !== -1;
		},
		getStorefrontOstock() {
			const ooWeb = this.ooWeb;
			return ooWeb.replace('app', 'inventro');
		},
		isOfficialSeller() {
			return isHasFeature(this.user, 'official_seller');
		},
		isProductPrivate() {
			return !!duplicateVar(isPrivate(this.product, this.user)); // duplicateVar to avoid reactivity, convert to boolean
		},
		isDisabled() {
			return this.isProductAdded || this.isProductPrivate;
		},
		productImage() {
			return this.product?.picture ?? this.defaultImage;
		},
		isCODEnabled() {
			return this.product?.payments.findIndex(payment => payment === 'cod') !== -1;
		},
		isLpEnabled() {
			return this.product?.pages?.length > 0 ?? false;
		},
		isMarketingKitEnabled() {
			return this.product?.marketing_kit?.visible ?? false;
		},
		favoriteIconStyle() {
			return {
				visibility: this.isAddingWishlist ? 'hidden' : 'visible',
				fontSize: '16px',
			};
		},
		productId() {
			let productId = null;
			if (this.product) {
				productId = this.product._id;
				if (typeof this.product._id === 'object') {
					productId = this.product._id.$oid;
				}
			}
			return productId;
		},
	},
	watch: {
		isEditMode() {
			this.isChecked = false;
		},
	},
};
</script>
<style lang="scss" scoped>
    .wrapper-box {
		max-width: 306px;
		// height: 470px;
		// padding: 16px;
		// background: white;
		border-radius: 5px;
		// overflow: hidden;
	}

	.product-img {
		padding: 0 !important;
		height: auto !important;
		border-top-left-radius: 5px;
		border-top-right-radius: 5px;
		overflow: hidden;

		// padding-top: 100%;
		// height: 0;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;

		img {
			position: relative !important;
			// max-height: none!important;

			width: 100%;
			flex-shrink: 0;
			min-width: 100%;
			min-height: 100%;
			max-width: 100%;
			// max-height: 100%;
			// max-height: 265px;
			object-fit: cover;
			// position: absolute;
			top: 0;
			bottom: 0;
			margin: auto;
			transition: 0.3s all cubic-bezier(0.45, 0.05, 0.55, 0.95);
			height: 200px;

			@media screen and (max-width: 540px) {
				max-height: 155px;
			}
		}
	}

	.product-detail-container {
		padding: 16px;

		.product-name {
			font-weight: 700;
			font-size: 14px;
			color: #4D4D4D;
			display: -webkit-box;
			max-width: 400px;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			overflow: hidden;
			text-overflow: ellipsis;
			height: 45px;
		}

		.product-detail {
			font-size: 12px;
			color: #616672;
			.product-price-detail {
				.capital {
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					font-size: 12px;
					font-weight: 600;
					.price {
						// color: #2B2F39;
						color: #ff9f1a;
					}

					@media (max-width: 575px) {
						font-size: 10px;
					}
				}
				.selling {
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					.price {
						// color: #2A7ED4;
						color: #2B2F39;
					}

					@media (max-width: 575px) {
						font-size: 9px;
					}
				}
			}
			.location-stock {
				.location {
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}
			}
		}

		.product-detail-button {
			margin-top: 12px;

			.btn-outline {
				@media screen and (max-width: 540px) {
					font-size: 12px;
				}
			}

			.dropdown {
				.dropdown-menu {
					border-radius: 8px;

					.dropdown-item {
						font-size: 13px;

						@media screen and (max-width: 540px) {
							font-size: 12px;
						}
					}
				}
			}
		}
	}

	@keyframes slide-up {
		0% {
			opacity: 0;
			transform: translateY(100%)
		}
		100% {
			opacity: 1;
			transform: translateY(0)
		}
	}

	@keyframes slide-down {
		0% {
			opacity: 0;
			transform: translateY(-100%)
		}
		100% {
			opacity: 1;
			transform: translateY(0)
		}
	}

	.origin {
		display: none;
	}

	.product-container:hover .origin {
		display: block;
		-webkit-animation: slide-up .3s ease-out;
		-moz-animation: slide-up .3s ease-out;
	}

	.product-container:hover .warehouse-label {
		display: none;
	}

	.product-container:not(:hover) .warehouse-label {
		display: block;
		-webkit-animation: slide-down .3s ease-out;
		-moz-animation: slide-down .3s ease-out;
	}

	.blur {
		border-radius: 5px;
		filter: blur(3px);
	}

	.label-sm {
		font-size: 11px !important;

		@media (max-width: 575px) {
			font-size: 8px !important;
		}
	}

	.label-700 {
		font-size: 12px;
		font-weight: 700;
		color: #616672;
		line-height: 20px;
	}

	.checkbox-container {
		position: absolute;
		top: 10px;
		right: 10px;
		z-index: 2;
	}

	.checkbox-blank {
		width: 24px;
		height: 24px;
		border: 2px solid white;
	}

	.rounded {
		border-radius: 5px;
	}
	.gradient-background {
		width: 100%;
		height: 30%;
		top: 0;
		position: absolute;
		z-index: 1;
		background: linear-gradient(to bottom, #00000073, transparent); /* Gradasi dari hitam ke hilang */
	}

	.plain-link {
		text-decoration: none !important;
	}

	.label-price {
		font-size: 12px;
		font-weight: 700;
		line-height: 20px;
	}

	.color-price {
		color: #ff9f1a;
	}

	.color-selling-price {
		color: #414756;
	}

	@media (max-width: 400px) {
		.label-700 {
			font-size: 11px;
		}
	}

	@media (min-width: 1024px) and (min-height:800px) {
		.btn-sell-now{
			font-size: 16px;
		}
	}

	@media (min-width: 360px) and (max-height:740px) {
		.btn-sell-now{
			font-size: 11px !important;
		}

		.label-700 {
			font-size: 11px !important;
		}
	}

	.ribbon-container {
		display: flex;
		flex-direction: column;
		position: absolute;
		left: -5px;
		top: 8px;
		z-index: 6;
	}

	.ribbon-text {
		width: 37px;
		height: 20px;
		padding: 4px 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 8px 8px 8px 0;
		font-size: 10px;
		font-weight: 800;
		line-height: 12px;
		letter-spacing: .1px;
		color: #fff;
		background: #f6455c;
	}

	.ribbon-tail {
		width: 5px;
		height: 5px;
		border-radius: 0 0 0 5px;
		background: #981030;
	}

	.sale-price {
		text-decoration: line-through;
		color: #929292;
		font-size: 10px;
	}

</style>
